import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-cnae-pj',
  templateUrl: './cnae-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./cnae-pj.component.css']
})
export class CnaePjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.cnae===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.cnae===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
